import { Box, Chip, Grid, MenuItem, Select, Typography } from "@mui/material";
import { CustomEvent } from "schemas/functions";

import TemplateEditButton from "components/TemplateEditButton";
import { Template } from "features/Influencer/ContactList/schema";

import styles from "./styles";

interface Props {
  templates: Template[];
  handleChange: (e: CustomEvent, index: number) => void;
  filteredOutreachTemplates: Template[];
  templateFromEmailSettings?: number[];
  hideEditTemplateButton?: boolean;
  addNewOption?: () => void;
}

const OutreachSelect = ({
  templates,
  handleChange,
  filteredOutreachTemplates,
  templateFromEmailSettings,
  hideEditTemplateButton = false,
  addNewOption = undefined,
}: Props) => {
  return (
    <Grid item xs container gap={1}>
      <Select
        value={templates[0]?.id}
        onChange={(e) => handleChange(e, 0)}
        defaultValue={templates[0]?.id}
        size="small"
        sx={{
          minWidth: "222px",
        }}
      >
        {!!addNewOption && (
          <MenuItem onClick={addNewOption}>
            <Box sx={styles.createButton}>Create New</Box>
          </MenuItem>
        )}
        {filteredOutreachTemplates?.map((template) => (
          <MenuItem key={template.id} value={template.id}>
            <Box
              display="flex"
              gap={1}
              flexWrap="wrap"
              sx={styles.templateName}
            >
              <Typography noWrap sx={{ maxWidth: 225 }}>
                {template.name}
              </Typography>
              {template.id &&
                templateFromEmailSettings?.includes(template.id) && (
                  <Chip
                    label="Last Used"
                    size="small"
                    sx={{
                      ml: 1,
                      fontSize: 10,
                      backgroundColor: "primary.light",
                    }}
                  />
                )}
            </Box>
          </MenuItem>
        ))}
      </Select>
      {templates[0]?.id && !hideEditTemplateButton && (
        <TemplateEditButton templateId={templates[0].id} />
      )}
    </Grid>
  );
};

export default OutreachSelect;
